import React from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { Chip } from '@warehouse/shared/legacy-ui';
import { NxObject, NxObjectType } from '@warehouse/object-browser/core';

export function StorageTierCell({ row }: GridRenderCellParams<NxObject, string>) {
	if (row.itemType !== NxObjectType.File) return null;
	return <Chip label={row.storageTier.label} />;
}
